//Fallback start
function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1);
  var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon/2) * Math.sin(dLon/2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  var d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI/180);
}

async function getDestination() {
  var cacheKey = 'destinationData';
  var cacheExpiryKey = 'destinationDataExpiry';
  var cacheExpiryHours = 24; // Cache for 24 hours

  // Check if cached data exists and is not expired
  var cachedData = localStorage.getItem(cacheKey);
  var cachedExpiry = localStorage.getItem(cacheExpiryKey);
  var now = new Date().getTime();

  if (cachedData && cachedExpiry && now < parseInt(cachedExpiry)) {
    // Use cached data
    return JSON.parse(cachedData);
  } else {
    // Fetch new data
    var response = await $.getJSON('https://sheets.googleapis.com/v4/spreadsheets/1ceivNchS6OznQXkdMODBpLBWddqaS-bTmrJX-fLc4Hw/values:batchGet?ranges=A1:Z1000&key=AIzaSyBxndKCpLv4kwiAu16Rvs-2acYybb_HQeo');
    var csvHeader = response.valueRanges['0'].values['0'];
    var data = [];
    for (i = 1; i < response.valueRanges['0'].values.length; i++) {
      var dataPush = [];
      for (x = 0; x < csvHeader.length; x++) {
        dataPush[csvHeader[x]] = response.valueRanges['0'].values[i][x];
      }
      data.push(dataPush);
    }
    // Cache the data
    localStorage.setItem(cacheKey, JSON.stringify(data));
    localStorage.setItem(cacheExpiryKey, (now + cacheExpiryHours * 60 * 60 * 1000).toString());
    return data;
  }
}

async function getNearestDealer (origin) {
  var destination = await getDestination();
  var i;
  var distance= [];
  for (i = 0; i < destination.length; i++) {
    var calDistance = getDistanceFromLatLonInKm(origin.lat, origin.long, destination[i].Latitude, destination[i].Longitude);
    distance[i] = {loc: destination[i].Shop_Name, dist: calDistance}
  }
  var lowest = Number.POSITIVE_INFINITY;
  var fclity = "";
  var tmp;
  for (i = 0; i < distance.length; i++) {
    tmp = distance[i].dist;
    if (tmp < lowest) {
      lowest = tmp;
      fclity = distance[i].loc;
    }
  }
  return fclity;
}

window.setDealer = async function () {
    geoip2.city(async function(response){
      var result = {lat: response.location.latitude , long: response.location.longitude, city: response.city.names.en};
      var nearestStore = await getNearestDealer (result);
      Cookies.set('nearestStore', nearestStore,{ expires: 1 });
      jQuery('#panel-hide').text(nearestStore);
      $('#panel-hide').load();
    }, onError)
    var onError = function(error){
    }
}

//Check if allowed
window.checkCookieStore = function() {
  var nearest = Cookies.get('nearestStore');
  console.log('nearest ', nearest);
  if (Cookies.get('nearestStore')) {
    return nearest;
  }
  else {
    return null;
  }
}

//Additional
window.getLocationCityLatLon = async function(lat,lon){
  var cacheKey = 'geocode_' + lat + '_' + lon;
  var cacheExpiryKey = 'geocodeExpiry_' + lat + '_' + lon;
  var cacheExpiryHours = 24; // Cache for 24 hours

  // Check if cached data exists and is not expired
  var cachedData = localStorage.getItem(cacheKey);
  var cachedExpiry = localStorage.getItem(cacheExpiryKey);
  var now = new Date().getTime();

  if (cachedData && cachedExpiry && now < parseInt(cachedExpiry)) {
    // Use cached data
    return JSON.parse(cachedData);
  } else {
    // Fetch new data
    var response = await $.getJSON('https://maps.googleapis.com/maps/api/geocode/json?latlng='+ lat + ',' + lon +'&key=AIzaSyBxndKCpLv4kwiAu16Rvs-2acYybb_HQeo', function() {});
    // Cache the data
    localStorage.setItem(cacheKey, JSON.stringify(response));
    localStorage.setItem(cacheExpiryKey, (now + cacheExpiryHours * 60 * 60 * 1000).toString());
    return response;
  }
}

var nearestStore = Cookies.get('nearestStore');
  if(!nearestStore){
    (function waitForGoogle() {
      var intervalId = setInterval(function() {
        if (typeof google !== 'undefined' && google.maps) {
          clearInterval(intervalId);
          var map = new google.maps.Map(document.getElementById('map-canvas-hide'), {
            zoom: 10,
            mapTypeId: google.maps.MapTypeId.ROADMAP
          });
          var panelDivnear = document.getElementById('panel-hide');

          var data = new DaiwaDataSource;

          var view = new storeLocator.View(map, data, {
            geolocation: true
          });
          new storeLocator.Panel(panelDivnear, {
            view: view
          });
        }
      }, 100);
    })();
  }
  else {
    jQuery(document).ready(function(){
      var payload = '<a class="find-a-store" href="/pages/find-a-store"><span class="store-list-near"><div class="title">'+ nearestStore +'</div></span></a>';
      $('#panel-hide').html(payload);
    });
  }
